import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class TrackingLinksManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/tracking-links',
      params,
      paramsSerializer: qs.stringify,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/tracking-links',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/tracking-links/${id}`,
      data,
    });

  createAutomatedLinks = () =>
    this.request({
      method: 'POST',
      url: '/automated-tracking-links',
    });
}
